const pages = {
  about: {
    title: 'About Reserve Connect',
    description: 'Connecting travelers to the best experiences in Serra Catarinense.',
  },
  contact: {
    title: 'Contact Us',
    description: 'Get in touch with our team.',
  },
  groups: {
    title: 'Groups & Agencies',
    description: 'Special solutions for groups and travel agencies.',
    formUnavailable: 'Form temporarily unavailable. Contact us via WhatsApp.',
  },
  cityGuide: {
    title: 'What to do in Urubici SC',
    subtitle: 'Attractions, Waterfalls & Adventures',
  },
  terms: { title: 'Terms of Use' },
  privacy: { title: 'Privacy Policy' },
  cookies: { title: 'Cookie Policy' },
  cancellation: { title: 'Cancellation & Refund Policy' },
  restaurants: { title: 'Restaurants in Urubici' },
  experiences: { title: 'Experiences in Urubici' },
  events: { title: 'Events in Urubici' },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist or has been moved.',
    backHome: 'Back to home',
  },
  city: {
    heroTitle: 'Accommodation in {{cityName}} with real-time availability',
    heroDescription: 'Book directly with local hotels, with automatic availability updates.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    guest_1: '1 guest',
    guest_2: '2 guests',
    guest_3: '3 guests',
    guest_4: '4 guests',
    guest_5: '5 guests',
    guest_6: '6+ guests',
    searchAvailability: 'Search availability',
    directBooking: 'No intermediaries. Direct confirmation with the hotel.',
    secureBooking: 'Secure booking',
    realAvailability: 'Real availability',
    verifiedHotels: 'Verified hotels',
  },
  ondeIr: {
    heroTitle: 'Discover what makes Urubici unforgettable',
    heroDescription: 'Lush nature, real cold weather and experiences that demand the right accommodation.',
    seeNearbyLodging: 'See accommodations near attractions',
    exploreRoutes: 'Explore itineraries',
    attractionsTitle: 'Attractions that define Urubici',
    attractionsDescription: 'Choose the experience that suits you and find the ideal accommodation nearby.',
    morroDaIgreja: 'Morro da Igreja',
    morroDaIgrejaDesc: 'One of the highest points in Southern Brazil, with stunning views and intense cold in winter.',
    seeLodgingNearby: 'See nearby accommodations',
    serraCorvoBranco: 'Serra do Corvo Branco',
    serraCorvoBrancoDesc: 'Scenic road with giant cliffs and a must-stop for motorcyclists.',
    lodgingForMotorcyclists: 'Ideal accommodations for motorcyclists',
    cachoeirasSerra: 'Mountain Waterfalls',
    cachoeirasSerraDesc: 'Preserved nature and trails for those seeking tranquility and contact with greenery.',
    searchNatureLodging: 'Search nature accommodations',
    centroHistorico: 'Historic Center',
    centroHistoricoDesc: 'Restaurants, cafes and easy access to the main city attractions.',
    seeDowntownLodging: 'See downtown accommodations',
    temporadaInverno: 'Winter Season',
    temporadaInvernoDesc: 'Frequent frost and possible snow — high demand during this season.',
    winterLodging: 'Winter accommodations',
    trilhasMirantes: 'Trails & Viewpoints',
    trilhasMirantesDesc: 'Outdoor experiences for those who enjoy adventure and unique landscapes.',
    exploreNearbyLodging: 'Explore nearby accommodations',
    routesTitle: 'Itineraries to experience Urubici',
    routesDescription: 'Plan your stay with organized experiences and choose the ideal accommodation for each travel profile.',
    winterRoute: 'Winter Itinerary — 2 days in the mountains',
    winterRouteDesc: 'Intense cold, fireplace, gastronomy and the main attractions over a perfect weekend.',
    seeWinterLodging: 'See winter accommodations',
    exploreFullRoute: 'Explore full itinerary',
    natureRoadRoute: 'Nature & Road Itinerary',
    natureRoadRouteDesc: 'Serra do Corvo Branco, viewpoints and trails for those who love the road, adventure and unique landscapes.',
    lodgingForBikers: 'Ideal accommodations for motorcyclists',
    seeRouteMap: 'See route map',
    whereToStayTitle: 'Where to stay for each experience',
    whereToStayDescription: 'Choose the ideal region and find accommodations that match your travel style.',
    centroRegion: 'Historic Center',
    centroRegionDesc: 'Ideal for those who want restaurants, cafes and easy access to the main attractions.',
    seeLodgingCentro: 'See accommodations in Centro',
    morroRegion: 'Morro da Igreja & High Altitude',
    morroRegionDesc: 'Perfect for those seeking intense cold, fireplace and stunning landscapes.',
    seeFireplaceChalets: 'See chalets with fireplace',
    serraRegion: 'Serra do Corvo Branco',
    serraRegionDesc: 'Road itineraries, viewpoints and accommodations with ample parking.',
    seeBikerLodging: 'See accommodations for motorcyclists',
    finalCtaTitle: 'Choose where to stay while experiencing Urubici',
    finalCtaDescription: 'The attractions impress. The right accommodation transforms the experience.',
    seeAvailableLodging: 'See available accommodations now',
    exploreAdvancedFilters: 'Explore advanced filters',
    realTimeAvailability: 'Real-time availability',
    directReservation: 'Direct booking',
    localSupport: 'Local support',
    cityPlaceholder: 'City',
    seoTitle: 'What to do in Urubici SC - Attractions',
    seoDescription: 'Discover what to do in Urubici, SC. Morro da Igreja, Serra do Corvo Branco, waterfalls, canyons and Serra Catarinense attractions.',
    breadcrumbHome: 'Home',
    breadcrumbWhatToDo: 'What to do',
  },
  restaurantes: {
    heroTitle: 'Flavors that warm Urubici\'s cold',
    heroDescription: 'From mountain gastronomy to cozy cafes, discover where to experience the full mountain experience.',
    seeNearbyLodging: 'See nearby accommodations',
    exploreRestaurants: 'Explore restaurants',
    filterByType: 'Filter by type',
    filterAll: 'All',
    filterFineDining: 'Fine Dining',
    filterCafes: 'Cafes',
    filterSteakhouse: 'Steakhouses',
    filterItalian: 'Italian',
    filterRegional: 'Regional',
    filterNearCenter: 'Near center',
    recommendedTitle: 'Recommended restaurants in Urubici',
    recommendedDescription: 'Local curation to complete your trip — especially in winter.',
    viewDetails: 'See details',
    nearbyLodging: 'Nearby accommodations →',
    highlySought: 'Highly sought after in winter',
    gastroAccommodationTitle: 'Gastronomy and accommodation go together',
    gastroAccommodationDesc: 'In winter, the most popular restaurants fill up early — and the best accommodations near the center sell out fast. Secure your base in Urubici and enjoy the experience in comfort.',
    bulletLessTravel: 'Less travel at night',
    bulletMoreComfort: 'More comfort in the cold',
    bulletBetterExperience: 'Better experience at attractions',
    seeDowntownLodging: 'See downtown accommodations',
    centroUrubici: 'Urubici Center',
    bestLocationGastro: 'The best location for gastronomy',
    finalCtaTitle: 'Already chose where to dine. Now choose where to stay.',
    finalCtaSubtitle: 'Secure your accommodation in Urubici with real-time availability and immediate confirmation.',
    seeAvailableNow: 'See available accommodations now',
    realTimeAvailability: 'Real-time availability',
    directLocalBooking: 'Direct booking with local establishments',
    whatsappSupport: 'Human support via WhatsApp',
    seoTitle: 'Restaurants in Urubici SC - Mountain Gastronomy',
    seoDescription: 'Discover the best restaurants in Urubici, SC. Fine dining, cafes, steakhouses and regional cuisine of the Serra Catarinense.',
    breadcrumbHome: 'Home',
    breadcrumbRestaurants: 'Restaurants',
  },
  restauranteDetalhes: {
    shareAriaLabel: 'Share',
    favoriteAriaLabel: 'Favorite',
    previousImage: 'Previous image',
    nextImage: 'Next image',
    idealFor: 'Ideal for',
    planYourNight: 'Plan your night',
    schedule: 'Hours',
    priceRange: 'Price range',
    highlightsSection: 'Highlights',
    seeNearbyLodging: 'See nearby accommodations',
    seeMoreRestaurants: 'See more restaurants',
    trustMicrocopy: 'Book your accommodation and enjoy the mountains in comfort.',
    aboutRestaurant: 'About this restaurant',
    showMore: 'Show more',
    showLess: 'Show less',
    highlightsTitle: 'Highlights',
    searchLodgingRegion: 'Search accommodation for this region',
    exploreUrubici: 'Explore Urubici',
    location: 'Location',
    howToGetThere: 'How to get there',
    easyAccess: 'Easy access via SC-110',
    nearCentro: 'Near Urubici Center',
    idealWalking: 'Ideal for walking from downtown accommodations',
    tip: 'Tip',
    tipText: 'In winter, prioritize nearby accommodations to avoid long commutes at night.',
    seeAttractionsNearby: 'See nearby attractions',
    customerReviews: 'Customer reviews',
    verifiedReviews: 'verified reviews',
    basedOnReal: 'Based on real visitor reviews.',
    viewAllReviews: 'See all reviews',
    reviewDisclaimer: 'Illustrative content. Reviews will be loaded dynamically in the future.',
    nearbyAccommodations: 'Nearby accommodations',
    nearbyDesc: 'Stay close to the center and enjoy the experience better.',
    startingAt: 'Starting at',
    perNight: '/ night',
    seeAllDowntown: 'See all downtown accommodations',
    similarRestaurants: 'Similar restaurants',
    similarRestaurantsDesc: 'Other options with the same cozy atmosphere for cold nights.',
    viewDetails: 'See details',
    realTimeAvailability: 'Real-time availability',
    directReservation: 'Direct booking',
    whatsappSupport: 'Human support via WhatsApp',
    finalCtaTitle: 'Combine dining and accommodation with comfort',
    reviewPerfectNight: '"Perfect night in the cold. Fireplace, wine and incredible dishes."',
    reviewImpeccable: '"Cozy atmosphere and impeccable service. We\'ll be back!"',
    service: 'Service',
    ambiance: 'Ambiance',
    flavor: 'Flavor',
    valueForMoney: 'Value for money',
    winterTip: 'In winter, securing a good base downtown makes all the difference to enjoy Urubici.',
    exploreMore: 'Explore more restaurants',
    seoTitle: 'Restaurant in Urubici - Details and Reviews',
  },
  experiencias: {
    seoTitle: 'Experiences in Urubici SC - Mountain Adventures',
    seoDescription: 'Live unique experiences in Urubici, SC. Canyons, waterfalls, horseback riding, tastings and adventures in the Serra Catarinense.',
    heroLabel: 'Discover the Mountains',
    heroTitle: 'Unforgettable Experiences',
    heroDescription: 'From extreme adventures to moments of contemplation, find the perfect activity for your stay in Urubici.',
    trustGuides: 'Certified Guides',
    trustGuidesSub: 'Experienced local professionals',
    trustInsurance: 'Adventure Insurance',
    trustInsuranceSub: 'Full coverage included',
    trustFlexible: 'Flexible Booking',
    trustFlexibleSub: 'Cancel up to 48h in advance',
    curatedTitle: 'Premium Curation',
    mainTitle: 'The Best of Urubici',
    mainDescription: 'Activities selected for all traveler styles',
    btnDetails: 'See details',
    ctaTitle: 'Ready for your next adventure?',
    ctaDescription: 'Book now and secure your spot in Urubici\'s most sought-after experiences. Instant confirmation directly with operators.',
    ctaSearchLodging: 'Find Accommodation',
    ctaNeedHelp: 'Need help?',
    talkToCentral: 'Talk to our reservations center',
    cards: [
      {
        id: 1,
        title: 'Espraiado Canyon Tour',
        description: 'One of the most stunning views of Serra Catarinense on an exclusive guided tour.',
        image: 'https://readdy.ai/api/search-image?query=stunning%20canyon%20view%20in%20brazilian%20mountains%20dramatic%20cliffs%20foggy%20valley%20morning%20light%20premium%20travel%20photography&width=800&height=600&seq=exp1',
        price: 'R$ 180',
        category: 'Adventure',
      },
      {
        id: 2,
        title: 'Altitude Wine Tasting',
        description: 'Visit Urubici\'s award-winning wineries with local cheese pairings.',
        image: 'https://readdy.ai/api/search-image?query=luxury%20winery%20tasting%20room%20view%20of%20vineyard%20at%20sunset%20wine%20glasses%20on%20table%20elegant%20atmosphere&width=800&height=600&seq=exp2',
        price: 'R$ 250',
        category: 'Gastronomy',
      },
      {
        id: 3,
        title: 'Sunrise Horseback Ride',
        description: 'Witness the mountain awakening on horseback through the high-altitude fields.',
        image: 'https://readdy.ai/api/search-image?query=horseback%20riding%20at%20sunrise%20in%20misty%20mountains%20silhouette%20outdoor%20adventure%20premium%20experience&width=800&height=600&seq=exp3',
        price: 'R$ 150',
        category: 'Nature',
      },
      {
        id: 4,
        title: 'Avencal Waterfall Expedition',
        description: 'Exclusive access and guided trails at the base of the region\'s largest waterfall.',
        image: 'https://readdy.ai/api/search-image?query=massive%20waterfall%20in%20brazilian%20nature%20lush%20green%20forest%20pristine%20environment%20natural%20beauty&width=800&height=600&seq=exp4',
        price: 'R$ 120',
        category: 'Adventure',
      },
      {
        id: 5,
        title: 'Morro da Igreja Picnic',
        description: 'Complete gourmet basket to enjoy the highest point in Southern Brazil.',
        image: 'https://readdy.ai/api/search-image?query=picnic%20with%20stunning%20mountain%20view%20gourmet%20basket%20wine%20comfortable%20setup%20golden%20hour&width=800&height=600&seq=exp5',
        price: 'R$ 320',
        category: 'Romantic',
      },
      {
        id: 6,
        title: 'Night Photography Tour',
        description: 'Capture the stars under Brazil\'s clearest sky with professional guidance.',
        image: 'https://readdy.ai/api/search-image?query=milky%20way%20night%20sky%20over%20mountains%20long%20exposure%20photography%20stunning%20nature&width=800&height=600&seq=exp6',
        price: 'R$ 200',
        category: 'Culture',
      },
    ],
    breadcrumbHome: 'Home',
    breadcrumbExperiences: 'Experiences',
  },
  eventos: {
    seoTitle: 'Events in Urubici SC - 2026 Calendar',
    seoDescription: 'Events calendar in Urubici, SC 2026. Festivals, motorcycle rallies, winter and cultural celebrations in Serra Catarinense.',
    heroTitle: 'Events in Urubici that move the mountains',
    heroDescription: 'Plan your trip in advance and secure the best accommodation for each season.',
    seeAvailableLodging: 'See available accommodations',
    seeFullCalendar: 'See full calendar',
    filterByType: 'Filter by type',
    filterAll: 'All',
    filterWinter: 'Winter',
    filterMotorcycle: 'Motorcycling',
    filterCulture: 'Culture',
    filterNature: 'Nature',
    upcomingEvents: 'Upcoming events in Urubici',
    upcomingEventsDesc: 'Plan your accommodation in advance for the most sought-after dates.',
    seeLodgingDates: 'See accommodations on these dates',
    realTimeDates: 'Real-time availability for event dates.',
    impactTitle: 'How events impact accommodation in Urubici',
    impactDescription: 'Special dates increase occupancy and sell out the best options faster.',
    occupancyCard1: '+60% winter occupancy',
    occupancyCard1Desc: 'Cold weekends tend to sell out chalets and inns with fireplaces.',
    occupancyCard2: 'Booking peak 30 days before',
    occupancyCard2Desc: 'Motorcycle rallies increase demand for accommodations with parking.',
    occupancyCard3: 'Frost and holidays sell out fast',
    occupancyCard3Desc: 'When the cold hits, demand grows in just a few hours.',
    seeLodgingTheseDates: 'See accommodations for these dates',
    exploreAdvancedFilters: 'Explore advanced filters',
    planTitle: 'Plan your trip for the events',
    planDescription: 'Organize your experience in Urubici in advance.',
    planRestaurants: 'Recommended restaurants',
    planRestaurantsDesc: 'Discover where to dine during events.',
    seeRestaurants: 'See restaurants',
    planRoute: '2-Day Itinerary',
    planRouteDesc: 'Suggested itinerary to enjoy the mountains.',
    exploreRoute: 'Explore itinerary',
    planHowToGet: 'How to get there',
    planHowToGetDesc: 'Access tips and best routes.',
    seeDirections: 'See directions',
    planWinterGear: 'What to bring in winter',
    planWinterGearDesc: 'Prepare for the intense cold.',
    seeTips: 'See tips',
    searchEventLodging: 'Search accommodation for the event',
    whyReserveTitle: 'Why book accommodation before events?',
    whyReserve1: 'High occupancy',
    whyReserve1Desc: 'during winter seasons',
    whyReserve2: 'Motorcycle rally',
    whyReserve2Desc: 'with high demand',
    whyReserve3: 'Cultural events and festivals',
    whyReserve3Desc: 'with limited availability',
    searchEventLodgingCta: 'Search accommodation for events',
    mainEventsTitle: 'Main events and seasons',
    mainEventsDesc: 'Discover the best times to visit Urubici and secure your accommodation',
    winterSeason: 'Winter Season',
    winterSeasonDesc: 'High demand for chalets and inns with fireplaces.',
    seeWinterLodging: 'See winter accommodations',
    motorcycleMeetup: 'Motorcycle Rally',
    motorcycleMeetupDesc: 'National meeting point with great flow in the mountains.',
    lodgingForBikers: 'Ideal accommodations for motorcyclists',
    festivalsCulture: 'Festivals & Culture',
    festivalsCultureDesc: 'Plan your stay for special events.',
    searchEventAccommodation: 'Search accommodation for events',
    notFoundEvent: 'Didn\'t find the event you\'re looking for? See all available accommodation options.',
    seeAllLodging: 'See all accommodations',
    finalCtaTitle: 'Secure your accommodation for upcoming events',
    finalCtaDesc: 'Avoid missing out on the most sought-after dates. Book now with real-time availability.',
    searchAvailableLodging: 'Search available accommodations',
    trustFooter: 'Instant confirmation • No hidden fees • Local support',
    breadcrumbHome: 'Home',
    breadcrumbEvents: 'Events',
    eventCulture: 'Culture',
    eventNature: 'Nature',
    eventWinter: 'Winter',
    eventMotorcycle: 'Motorcycling',
    highDemand: 'High demand on event dates',
    faqQuestion1: 'When is the best time to visit Urubici?',
    faqAnswer1: 'Winter (June-August) is ideal for those seeking cold and frost possibilities. Summer is perfect for waterfalls and trails. Each season has its own special charm.',
    faqQuestion2: 'Are the events free?',
    faqAnswer2: 'Some events are free, others require tickets. We recommend checking the specific schedule for each event and booking accommodation in advance.',
  },
  contato: {
    seoTitle: 'Contact - Reserve Connect Urubici',
    seoDescription: 'Get in touch with the Reserve Connect Urubici Reservations Center. WhatsApp support for questions about accommodations and events.',
    heroLabel: 'Support',
    heroTitle: 'Talk to the Reserve Connect Center',
    heroDescription: 'Questions about accommodations, events, groups or your booking? We can help.',
    whatsappButton: 'Chat on WhatsApp',
    sendMessage: 'Send message',
    whatsappCardTitle: 'WhatsApp',
    whatsappCardDesc: 'Human and agile support for your questions.',
    startChat: 'Start chat',
    emailCardTitle: 'Email',
    emailCardDesc: 'Ideal for complex or formal requests.',
    emailResponseTime: 'Response within 24h',
    faqCardTitle: 'Frequently Asked Questions',
    faqCardDesc: 'The answers you need right now.',
    accessFaq: 'Access FAQ',
    newMessage: 'New message',
    sending: 'Sending...',
    formTitle: 'Send a message',
    formName: 'Name',
    formNamePlaceholder: 'Your full name',
    formWhatsapp: 'WhatsApp',
    formEmail: 'Email',
    formEmailOptional: '(optional)',
    formSubject: 'Subject',
    formSubjectPlaceholder: 'Select a subject',
    formSubjectReservation: 'Booking',
    formSubjectLodging: 'Accommodations',
    formSubjectEvents: 'Events',
    formSubjectGroups: 'Groups & Agencies',
    formSubjectOther: 'Other',
    formMessage: 'Message',
    formMessagePlaceholder: 'How can we help?',
    formCharLimit: 'Character limit: 500',
    formSubmit: 'Send message',
    formReturnTime: 'We respond within 24h.',
    formWhatsappSupport: 'Human support via WhatsApp',
    finalCtaTitle: 'Plan your trip with peace of mind.',
    seeAvailableLodging: 'See available accommodations',
    realTimeAvailability: 'Real-time availability',
    directReservation: 'Direct booking',
    localSupport: 'Local support',
    breadcrumbHome: 'Home',
    breadcrumbContact: 'Contact',
  },
  sobre: {
    seoTitle: 'About Urubici SC - Complete City Guide',
    seoDescription: 'Discover Urubici, the pearl of Serra Catarinense. History, climate, best time to visit and everything about this unique destination in southern Brazil.',
    heroTitle: 'Urubici by Reserve Connect',
    heroDescription: 'A platform created to connect travelers to the best experiences and accommodations in the mountains.',
    seeAvailableLodging: 'See available accommodations',
    exploreCity: 'Explore the city',
    positioningTitle: 'More than a website. A local booking infrastructure.',
    positioningDescription: 'Reserve Connect was born with a clear purpose: to organize the supply of accommodations, restaurants and experiences in Urubici on a modern, secure and conversion-focused platform.',
    techTitle: 'Proprietary Technology',
    techDesc: 'Real-time availability and integration with the local network.',
    curationTitle: 'Regional Curation',
    curationDesc: 'Selected and verified establishments.',
    supportTitle: 'Human Support',
    supportDesc: 'Service via WhatsApp and reservations center.',
    howItWorks: 'How it works',
    howItWorksDesc: 'A simple, direct and secure journey.',
    step1Title: 'Choose your experience',
    step1Desc: 'Accommodations, restaurants, events or itineraries.',
    step2Title: 'Compare and plan',
    step2Desc: 'Smart filters and clear information.',
    step3Title: 'Book with confidence',
    step3Desc: 'Real-time availability and immediate confirmation.',
    step4Title: 'Experience Urubici',
    step4Desc: 'With local support and curated experiences.',
    searchLodgingNow: 'Search accommodation now',
    connectedTitle: 'Connected to the local Urubici network',
    connectedDesc: 'Reserve Connect integrates local establishments, reservations center and proprietary technology to organize the city\'s tourism offering.',
    securePlatform: 'Secure platform',
    protectedPayment: 'Protected payment',
    humanSupport: 'Human support',
    talkToCentral: 'Talk to the center',
    commitmentTitle: 'Commitment to the city',
    commitment1: 'Partnership with local accommodations',
    commitment2: 'Organization of the tourism offering',
    commitment3: 'Focus on conversion and regional sustainability',
    finalCtaTitle: 'Plan your next trip to Urubici with confidence.',
    finalCtaDesc: 'Technology, local curation and human support for a complete experience.',
    realTimeAvailability: 'Real-time availability',
    whatsappSupport: 'WhatsApp support',
    breadcrumbHome: 'Home',
    breadcrumbAbout: 'About Urubici',
  },
  grupos: {
    heroTitle: 'Coming to Urubici with a group or agency?',
    heroDescription: 'Special conditions for excursions, motorcycle clubs, corporate events and organized trips.',
    requestProposal: 'Request group proposal',
    talkToWhatsapp: 'Talk to a consultant on WhatsApp',
    sectionTitle: 'Who we organize accommodations for',
    sectionDescription: 'We structure the best solution for each group profile.',
    motoclubes: 'Motorcycle Clubs',
    motoclubesDesc: 'Ample parking, easy access and accommodations prepared for groups of motorcyclists.',
    motoclubesCta: 'Request proposal for motorcycle club',
    excursions: 'Excursions',
    excursionsDesc: 'Simplified organization for tour groups and collective trips.',
    excursionsCta: 'Request proposal for excursion',
    corporate: 'Corporate',
    corporateDesc: 'Business events, training and executive meetings in the mountains.',
    corporateCta: 'Request corporate proposal',
    churches: 'Churches & Retreats',
    churchesDesc: 'Spiritual retreats and gatherings with adequate structure for groups.',
    churchesCta: 'Request retreat proposal',
    whyTitle: 'Why organize with Reserve Connect?',
    whyDescription: 'We centralize negotiations and structure the best accommodation for your group in Urubici.',
    benefit1: 'Centralized negotiation with the local network',
    benefit2: 'Curation of ideal accommodations for groups',
    benefit3: 'Human support via WhatsApp',
    benefit4: 'Flexibility for dates, profiles and budget',
    benefit5: 'Support before, during and after the trip',
    highlight1: 'Response within 24h',
    highlight2: 'Special conditions for groups',
    highlight3: 'Local support',
    formTitle: 'Request a proposal for your group',
    formDescription: 'Tell us about the group profile and dates. We\'ll return with the best accommodation options in Urubici.',
    formSuccessTitle: 'We\'ve received your request!',
    formSuccessMessage: 'Our team will get back to you shortly on WhatsApp.',
    formSendAnother: 'Send another request',
    formError: 'An error occurred while sending. Please try again.',
    formName: 'Full name',
    formCompany: 'Company/Group',
    formCompanyPlaceholder: 'Company or group name',
    formGroupType: 'Group type',
    formGroupTypePlaceholder: 'Select type',
    formGroupTypeMotoclube: 'Motorcycle Club',
    formGroupTypeExcursao: 'Excursion',
    formGroupTypeCorporativo: 'Corporate',
    formGroupTypeIgreja: 'Church/Retreat',
    formGroupTypeOther: 'Other',
    formQuantity: 'Number of people',
    formQuantityPlaceholder: 'E.g.: 20',
    formStartDate: 'Start date',
    formEndDate: 'End date',
    formWhatsapp: 'WhatsApp',
    formEmail: 'Email',
    formEmailPlaceholder: 'your@email.com',
    formMessage: 'Message',
    formMessagePlaceholder: 'Tell us more about your group, special needs or questions...',
    formCharLimit: 'characters',
    formSending: 'Sending...',
    formSubmit: 'Receive personalized proposal',
    formMicrocopy: 'We respond within 24h. Human support via WhatsApp.',
  },
  legal: {
    lastUpdated: 'Last updated: March 2026.',
    terms: {
      institutional: 'Institutional',
      heroTitle: 'Terms of Use',
      heroDescription: 'Rules and conditions for using the Reserve Connect platform.',
      seeAvailableLodging: 'See available accommodations',
      talkToCentral: 'Talk to the Center',
      section1Title: '1. About the Platform',
      section1Body: 'Reserve Connect is a private intermediation platform for accommodations and tourist experiences in Urubici, connecting travelers to local partner establishments.',
      section2Title: '2. Intermediation',
      section2Body: 'The platform acts as an intermediary between travelers and establishments. Reservations are made directly with registered partners.',
      section3Title: '3. Availability and Information',
      section3Body: 'Availability, price and condition information is provided by partner establishments and may change without prior notice.',
      section4Title: '4. Cancellations',
      section4Body: 'Cancellation policies follow the rules defined by each partner establishment, and the user must consult them before confirming the reservation.',
      section5Title: '5. User Responsibilities',
      section5Body: 'The user agrees to provide correct and updated information when making requests or reservations on the platform.',
      section6Title: '6. Limitation of Liability',
      section6Body: 'Reserve Connect is not responsible for events arising from the provision of services by partners, acting exclusively as a connection facilitator.',
      section7Title: '7. Changes to Terms',
      section7Body: 'These Terms of Use may be updated periodically to reflect platform improvements or legal compliance.',
      section8Title: '8. Contact',
      section8Body: 'For further clarification, contact our Reservations Center.',
      finalCtaTitle: 'Plan your next trip to Urubici with confidence.',
      finalCtaDesc: 'Technology, local curation and human support for a complete experience.',
      talkToCentralCta: 'Talk to the center',
      realTimeAvailability: 'Real-time availability',
      directReservation: 'Direct booking',
      whatsappSupport: 'WhatsApp support',
    },
    privacy: {
      heroLabel: 'Privacy',
      heroTitle: 'Privacy Policy',
      heroDescription: 'How we collect, use and protect your data when using Reserve Connect.',
      seeAvailableLodging: 'See available accommodations',
      talkToCentral: 'Talk to the Center',
      section1Title: '1. Purpose of this Policy',
      section1Body: 'This Privacy Policy describes how Reserve Connect collects and uses information to enable the operation of the platform and improve the user experience.',
      section2Title: '2. Data We May Collect',
      section2Body: 'We may collect data provided by you (such as name, email and WhatsApp in forms), as well as technical browsing data (such as pages accessed and device type) for security and platform improvement purposes.',
      section3Title: '3. Use of Information',
      section3Body: 'We use the data to: (a) respond to requests and proposals, (b) improve navigation and performance, (c) prevent fraud and ensure security, and (d) enable contact with the Center when requested.',
      section4Title: '4. Sharing with Partners',
      section4Body: 'When necessary for service or proposal requests, information may be shared with local partner establishments, strictly to enable the requested service.',
      section5Title: '5. Cookies and Similar Technologies',
      section5Body: 'Reserve Connect may use cookies to remember preferences and analyze site usage. You can manage cookies through your browser.',
      section6Title: '6. Security',
      section6Body: 'We adopt technical and organizational measures to protect data against unauthorized access, alteration or disclosure.',
      section7Title: '7. Your Rights',
      section7Body: 'You may request correction, update or removal of provided data through our service channel.',
      section8Title: '8. Retention',
      section8Body: 'We will retain data only for the time necessary to fulfill the purposes described in this policy or legal obligations.',
      section9Title: '9. Contact',
      section9Body: 'For privacy-related requests, contact the Reservations Center.',
      finalCtaTitle: 'Privacy and transparency in every connection.',
      finalCtaDesc: 'Technology, local curation and human support for a complete and secure experience.',
      talkToCentralCta: 'Talk to the center',
      realTimeAvailability: 'Real-time availability',
      directReservation: 'Direct booking',
      whatsappSupport: 'WhatsApp support',
    },
    cookies: {
      institutional: 'Institutional',
      heroTitle: 'Cookie Policy',
      heroDescription: 'Understand how we use cookies to improve your experience and make browsing safer.',
      seeAvailableLodging: 'See available accommodations',
      talkToCentral: 'Talk to the Center',
      section1Title: '1. What are cookies',
      section1Body: 'Cookies are small text files sent and stored on your computer or mobile device through your browser. They allow the website to "remember" your actions and preferences over time, making navigation easier and personalizing your experience.',
      section2Title: '2. Why we use cookies',
      section2Body: 'We use cookies for various essential and analytical purposes, including:',
      section2Item1Title: 'Functionality and performance:',
      section2Item1Desc: 'To ensure the site loads correctly and basic functionalities operate without errors.',
      section2Item2Title: 'Browsing preferences:',
      section2Item2Desc: 'To remember your choices, such as language and search filters, so you don\'t need to reconfigure them.',
      section2Item3Title: 'Metrics and continuous improvement:',
      section2Item3Desc: 'To understand how users interact with the platform, which pages are most visited and where we can improve.',
      section3Title: '3. Types of cookies',
      section3EssentialsTitle: 'Essential Cookies',
      section3EssentialsDesc: 'Indispensable for the website to function. Without them, basic booking and security services cannot be provided.',
      section3PerformanceTitle: 'Performance and Analytical Cookies',
      section3PerformanceDesc: 'Collect anonymous information about how the site is used. Help us fix issues and improve browsing speed.',
      section3FunctionalTitle: 'Functional Cookies',
      section3FunctionalDesc: 'Enable advanced functionalities and personalization, retaining choices made by the user during the session.',
      section3MarketingTitle: 'Marketing Cookies',
      section3MarketingDesc: 'Used to display relevant ads to the user profile or limit the frequency of ad display.',
      section4Title: '4. How to manage cookies',
      section4Body: 'You can manage or disable cookies directly in your browser settings (Chrome, Safari, Firefox, Edge, etc.). However, note that blocking essential cookies may prevent some parts of Reserve Connect from working correctly, such as the booking process.',
      section5Title: '5. Updates to this policy',
      section5Body: 'This policy may be updated periodically to reflect changes in our practices or for operational, legal or regulatory reasons. We recommend checking this page regularly.',
      finalCtaTitle: 'Transparency and security at every step.',
      finalCtaDesc: 'Technology, local curation and human support for a complete and secure experience.',
      talkToCentralCta: 'Talk to the center',
      realTimeAvailability: 'Real-time availability',
      directReservation: 'Direct booking',
      whatsappSupport: 'WhatsApp support',
    },
    cancellation: {
      heroLabel: 'Policies',
      heroTitle: 'Cancellation & Refund',
      heroDescription: 'Understand the rules and procedures for cancellations and refund requests.',
      seeAvailableLodging: 'See available accommodations',
      talkToCentral: 'Talk to the Center',
      section1Title: '1. General Rules',
      section1Body: 'Reserve Connect acts as an intermediary between the traveler and partner establishments. Cancellation and refund policies vary by partner and must be consulted at the time of booking.',
      section2Title: '2. Cancellation Deadlines',
      section2Body: 'Each establishment defines its own cancellation deadlines without penalty. Generally, cancellations made well in advance allow full or partial refund, according to the chosen rate rule.',
      section3Title: '3. Request Procedure',
      section3Body: 'To request a cancellation, the user must contact our Reservations Center directly via WhatsApp or email, providing the booking number and the reason for the request.',
      section4Title: '4. Refund Processing',
      section4Body: 'Once the refund is approved by the partner establishment, processing will be done through the same payment method used in the booking. The time for the credit to appear on the statement depends on the card operator or bank.',
      section5Title: '5. No-Show',
      section5Body: 'Failure to show up on the check-in date without prior notice within the established deadlines will be considered a "no-show" and will result in the loss of the amount paid, according to the partner\'s specific policy.',
      section6Title: '6. Force Majeure or Fortuitous Events',
      section6Body: 'In exceptional situations that prevent the provision of service by the partner or the traveler\'s travel, requests will be analyzed individually seeking the best solution for both parties.',
      finalCtaTitle: 'Security and support in every booking.',
      finalCtaDesc: 'Technology, local curation and human support for a complete and worry-free experience.',
      talkToCentralCta: 'Talk to the center',
      realTimeAvailability: 'Real-time availability',
      directReservation: 'Direct booking',
      whatsappSupport: 'WhatsApp support',
    },
  },
  tripPlanner: {
    pageTitle: 'Plan Your Trip',
    pageDescription: 'Build your ideal itinerary with lodging, restaurants, experiences, and events in the Serra Catarinense.',
    title: 'Plan Your Trip',
    subtitle: 'Tell us your dates and interests so we can build the perfect itinerary for you.',
    stepDates: 'When are you going?',
    stepInterests: 'What interests you?',
    interestsHint: 'Select the themes that best match your trip.',
    continue: 'Continue',
    planMyTrip: 'Plan my trip',
    planning: 'Planning...',
    planError: 'Could not generate itinerary. Please try again.',
    datesRequired: 'Please select check-in and check-out dates.',
    yourItinerary: 'Your Itinerary',
    day: 'Day',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    relaxDay: 'Free day to explore at your own pace.',
    whereToStay: 'Where to stay',
    noLodging: 'No lodging found for these dates.',
    perNight: 'night',
    seeAllLodging: 'See all lodging',
    eventsNearby: 'Events nearby',
    seeAllEvents: 'See all events',
    saveYourPlan: 'Save itinerary',
    saveHint: 'Save your itinerary to access later and share.',
    savePlan: 'Save itinerary',
    saving: 'Saving...',
    planSaved: 'Itinerary saved!',
    planSavedDesc: 'Your itinerary has been saved. Use the link below to share or access later.',
    shareLink: 'Itinerary link',
    copied: 'Copied!',
    backToResults: 'Back to itinerary',
    planAnotherTrip: 'Plan another trip',
    newSearch: 'New search',
  },
};
export default pages;
